export const getImageGrid = (imageCount: number) => {
  let gridArr: string[] = [];
  switch (imageCount) {
    case 1:
      gridArr = ["1 / 1 / 13 / 13"];
      break;
    case 2:
      gridArr = ["1 / 1 / 13 / 7", "1 / 7 / 13 / 13"];
      break;
    case 3:
      gridArr = ["1 / 1 / 13 / 7", "1 / 7 / 7 / 13", "7 / 7 / 13 / 13"];
      break;
    case 4:
      gridArr = [
        "1 / 1 / 13 / 7",
        "1 / 7 / 7 / 13",
        "7 / 7 / 13 / 10",
        "7 / 10 / 13 / 13",
      ];
      break;
    case 5:
      gridArr = [
        "1 / 1 / 13 / 7",
        "1 / 7 / 7 / 10",
        "1 / 10 / 7 / 13",
        "7 / 7 / 13 / 10",
        "7 / 10 / 13 / 13",
      ];
      break;
    case 6:
      gridArr = [
        "1 / 1 / 13 / 6",
        "1 / 6 / 7 / 10",
        "7 / 6 / 13 / 10",
        "1 / 10 / 5 / 13",
        "5 / 10 / 9 / 13",
        "9 / 10 / 13 / 13",
      ];
      break;
  }

  return gridArr;
};

export function formatPrice(
  amount: number,
  currency: string = "USD",
  locale: string = "en-US"
): string {
  return new Intl.NumberFormat(locale, { style: "currency", currency }).format(
    amount
  );
}

export function formatDateToYYYYMM(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  return `${year}${month}`;
}

export const formatPhoneNumber = (phone: string): string => {
  let cleaned = phone.trim();

  cleaned = cleaned.replace(/[^\d]/g, "");

  if (cleaned.length === 10 && cleaned.startsWith("0")) {
    cleaned = "32" + cleaned.slice(1);
  }

  if (cleaned.startsWith("0032")) {
    cleaned = cleaned.replace(/^0032/, "32");
  }

  if (!cleaned.startsWith("32")) {
    return phone;
  }

  const afterCode = cleaned.slice(2);

  if (afterCode.length !== 9) {
    return phone;
  }

  const part1 = afterCode.slice(0, 3);
  const part2 = afterCode.slice(3, 5);
  const part3 = afterCode.slice(5, 7);
  const part4 = afterCode.slice(7, 9);

  return `+32 ${part1}/${part2}.${part3}.${part4}`;
};

export const formatVAT = (vat: string): string => {
  const cleaned = vat.replace(/\D/g, "");
  let prefix = vat.toUpperCase().startsWith("BE") ? "BE" : "";

  const vatNumber = cleaned.slice(-10);
  if (vatNumber.length !== 10) return vat;

  return `${prefix} ${vatNumber.slice(0, 4)}.${vatNumber.slice(
    4,
    7
  )}.${vatNumber.slice(7)}`;
};
export const formatDateToDDMMYYYY = (dateInput: string | Date) => {
  if (typeof dateInput === "string") return dateInput;
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (isNaN(date.getTime())) return ""; // Invalid date

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};
export const formatDateToDDMMYYYYRaw = (dateInput: string | Date) => {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (isNaN(date.getTime())) return dateInput;

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}${month}${year}`;
};
export const formatDateToYYYYMMDD = (dateInput: string | Date) => {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (isNaN(date.getTime())) return "";


  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
};

export const formatDate = (date: Date | undefined | string) => {
  if(typeof date === "string") return date;
  return date ? date.toISOString().split("T")[0] : "";
}

export const base64ToBlob = (base64: string, contentType = "") => {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let i = 0; i < byteCharacters.length; i += 512) {
    const slice = byteCharacters.slice(i, i + 512);

    const byteNumbers = new Array(slice.length);
    for (let j = 0; j < slice.length; j++) {
      byteNumbers[j] = slice.charCodeAt(j);
    }

    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: contentType });
};